"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSsoEnabledRequestStatus = exports.getSaveExemptUsersRequestStatus = exports.getUpdateSamlRequirementRequestStatus = exports.getSaveSamlSettingsRequestStatus = exports.getFetchSamlSettingsRequestStatus = exports.getDeleteSamlSettingsRequestStatus = exports.getConfirmSamlSettingsRequestStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getConfirmSamlSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.SingleSignonApiActionTypes.CONFIRM_SAML_SETTINGS);
exports.getConfirmSamlSettingsRequestStatus = getConfirmSamlSettingsRequestStatus;
var getDeleteSamlSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.SingleSignonApiActionTypes.DELETE_SAML_SETTINGS);
exports.getDeleteSamlSettingsRequestStatus = getDeleteSamlSettingsRequestStatus;
var getFetchSamlSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.SingleSignonApiActionTypes.FETCH_SAML_SETTINGS);
exports.getFetchSamlSettingsRequestStatus = getFetchSamlSettingsRequestStatus;
var getSaveSamlSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.SingleSignonApiActionTypes.SAVE_SAML_SETTINGS);
exports.getSaveSamlSettingsRequestStatus = getSaveSamlSettingsRequestStatus;
var getUpdateSamlRequirementRequestStatus = (0, _getRequestStatus.default)(_actions.SingleSignonApiActionTypes.UPDATE_SAML_REQUIREMENT);
exports.getUpdateSamlRequirementRequestStatus = getUpdateSamlRequirementRequestStatus;
var getSaveExemptUsersRequestStatus = (0, _getRequestStatus.default)(_actions.SingleSignonApiActionTypes.SAVE_EXEMPT_USERS);
exports.getSaveExemptUsersRequestStatus = getSaveExemptUsersRequestStatus;
var getSsoEnabledRequestStatus = (0, _getRequestStatus.default)(_actions.SingleSignonApiActionTypes.GET_SSO_ENABLED);
exports.getSsoEnabledRequestStatus = getSsoEnabledRequestStatus;